import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Injectable } from '@angular/core';
import { getSvgIconData, SvgIcon } from '../utils/svg-icon';
import { Location } from '@angular/common';

@Injectable()
export class SvgIconService {
  svgIcons = Object.values(SvgIcon);
  svgIconData = getSvgIconData(this.location.prepareExternalUrl('assets/images/'));

  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private location: Location  ) {
  }

  init() {
    this.svgIcons.forEach((svgIcon) => {
      this.matIconRegistry.addSvgIcon(
        svgIcon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(this.svgIconData[svgIcon])
      );
    });
  }
}
